import { render, staticRenderFns } from "./Authorization_management.vue?vue&type=template&id=48e5b138"
import script from "./Authorization_management.vue?vue&type=script&lang=js"
export * from "./Authorization_management.vue?vue&type=script&lang=js"
import style0 from "./Authorization_management.vue?vue&type=style&index=0&id=48e5b138&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports